import { fetcher } from "helpers/fetcher";

import {
  TGetIndustrialAccidentCompensationReq,
  TGetIndustrialAccidentCompensationRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getIndustrialAccidentCompensation = async (
  params: TGetIndustrialAccidentCompensationReq
) => {
  return await fetcher<
    TGetIndustrialAccidentCompensationRes,
    TGetIndustrialAccidentCompensationReq
  >(ENDPOINT.CORPORATION.GET_INDUSTRIAL_ACCIDENT_COMPENSATION, {
    params: params,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_INDUSTRIAL_ACCIDENT_COMPENSATION.version,
    },
  });
};

export const queryGetIndustrialAccidentCompensation = async (
  params: TGetIndustrialAccidentCompensationReq
) => {
  return (await getIndustrialAccidentCompensation(params)).data;
};

queryGetIndustrialAccidentCompensation._key = (
  params: TGetIndustrialAccidentCompensationReq,
  key?: string
) => [
  ENDPOINT.CORPORATION.GET_INDUSTRIAL_ACCIDENT_COMPENSATION.url,
  params,
  key,
];
